import React from "react"
import types from "prop-types"
import GlobalHeaderNavLinkItem from "./GlobalHeaderNavLinkItem"
import GlobalHeaderNavDropdownItem from "./GlobalHeaderNavDropdownItem"

const GlobalHeaderNavItem = ({
  tab, isActiveTab, index, tabRef, navIsHorizontal, handleKeyDown, onClick,
}) => {
  const {
    title, icon, path, options,
  } = tab

  const renderDropdownItem = Boolean(options)

  if (renderDropdownItem) {
    return (
      <GlobalHeaderNavDropdownItem
        title={title}
        icon={icon}
        options={options}
        isActiveTab={isActiveTab}
        index={index}
        tabRef={tabRef}
        navIsHorizontal={navIsHorizontal}
        handleKeyDown={handleKeyDown}
        onOptionClick={onClick}
      />
    )
  }

  return (
    <GlobalHeaderNavLinkItem
      title={title}
      icon={icon}
      path={path}
      isActiveTab={isActiveTab}
      index={index}
      tabRef={tabRef}
      navIsHorizontal={navIsHorizontal}
      handleKeyDown={handleKeyDown}
      onClick={onClick}
    />
  )
}

GlobalHeaderNavItem.propTypes = {
  tab: types.shape({
    title: types.string.isRequired,
    icon: types.string.isRequired,
    path: types.string,
    options: types.arrayOf(types.shape({
      title: types.string.isRequired,
      path: types.string.isRequired,
    })),
  }).isRequired,
  isActiveTab: types.bool.isRequired,
  index: types.number.isRequired,
  tabRef: types.shape({ current: types.array }).isRequired,
  navIsHorizontal: types.bool.isRequired,
  handleKeyDown: types.func.isRequired,
  onClick: types.func.isRequired,
}

export default GlobalHeaderNavItem
